import { connect } from 'react-redux';
import newBookRequest from '../../components/NewBookRequest/NewBookRequest';
import * as newBookRequestActions from '../../actions/newBook';

const mapStateToProps = ({ newBook }) => ({
  newBookOrdersList: newBook.newBookOrdersList,
  bookOrderIdData: newBook.bookOrderIdData,
  addNewOrderData: newBook.addNewOrderData,
});

const mapDispatchToProps = dispatch => ({
  newBookRequestList: dates => dispatch(newBookRequestActions.newBookRequestList(dates)),
  newBookRequestId: requestId => dispatch(newBookRequestActions.newBookRequestId(requestId)),
  addNewBookToOrder: (values, requestId) => dispatch(newBookRequestActions.addNewBookToOrder(values, requestId)),
  addBookRequest: values => dispatch(newBookRequestActions.addBookRequest(values)),
  deleteBookRequest: requestId => dispatch(newBookRequestActions.deleteBookRequest(requestId)),
  editNewBook: (values, bookId, parentId) => dispatch(newBookRequestActions.editNewBook(values, bookId, parentId)),
  deleteNewBook: (bookId, parentId) => dispatch(newBookRequestActions.deleteNewBook(bookId, parentId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(newBookRequest);
